<template>
  <div
    class="relative flex flex-col rounded-2xl bg-white p-4 text-xs opacity-0 transition-[box-shadow] duration-300 hover:shadow-md"
  >
    <slot />

    <NuxtLink
      v-if="permalink"
      class="absolute inset-0 block"
      :aria-label="label"
      :to="permalink"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  permalink?: string
}>()
</script>
